import React, { Component, createRef, Fragment } from "react";
import { connect } from "react-redux";
import * as queryString from "query-string";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import "containers/ShowMore/Categories/styles.scss";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { CategoryGames } from "component/list";

import { CategoryFiltersComponent } from "component/filters";

import { CommonHeader } from "component/common";
import ShowMoreFilters from "containers/ShowMoreFilters";
import { ProviderTypeListItem } from "component/listItem";
import { fromJS } from "immutable";

const SEE_ALL_MODAL = "SEE_ALL_MODAL";
class ShowMoreCategories extends Component {
  constructor(props) {
    super(props);
    this.seeMoreRef = createRef();
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.loadList = this._loadList.bind(this);
    this.getTournamentPreview = this._getTournamentPreview.bind(this);
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onShowMoreHandler = this._onShowMoreHandler.bind(this);
    this.onFilterClickHandler = this._onFilterClickHandler.bind(this);
    this.onFilterClearHandler = this._onFilterClearHandler.bind(this);
    this.onApplyFilterClickHandler = this._onApplyFilterClickHandler.bind(this);
    this.state = {
      skeleton: [1, 2, 3, 4, 5, 6],
      showCategoryLabel: false,
      activeFilter: null,
    };
  }

  _onFilterClickHandler(subCategory, value) {
    this.props.setActiveFilter(this.props.filtersLink, subCategory, value);
  }

  _onFilterClearHandler(subCategory) {
    this.props.clearFilterByCategory(
      this.props.filtersLink.get("rel"),
      subCategory
    );
  }

  _onApplyFilterClickHandler() {
    this.props.showFilters(!this.props.filtersVisible);
  }

  _onShowMoreHandler(rel, route) {
    let params = {
      showMore: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
    };
    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onClickPrevious() {
    this.props.goBack(
      `${this.props.location.pathname}${this.props.location.search}`
    );
    this.props.history.goBack();
  }

  _getTournamentPreview(links) {
    if (!links) return;

    let link = links.find((link) => {
      return link.get("rel").indexOf("tournament.preview") > -1;
    });
    if (link)
      this.props.fetchTournamentPreview(link, {
        parentRel: this.props.route.get("rel"),
      });
  }

  _onGameItemClickHandler(game, rel) {
    let gameId = game.get("gameId");
    let nav = this.props.link ? this.props.link.get("rel") : null;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  _loadList(route, filters, sortBy, page) {
    if (!route) return;

    let params = new URLSearchParams();
    params.append("size", this.props.size);
    params.append("page", page ? page : 1);

    if (sortBy) {
      params.append("sortBy", sortBy);
    }

    if (filters) {
      filters.forEach((filter) => {
        filter.get("values").forEach((value) => {
          if (value.get("toggled") === true) {
            params.append(filter.get("id"), value.get("id"));
          }
        });
      });
    }
    this.props.fetchGames(route, params);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showMoreRel !== this.props.showMoreRel) {
      if (!nextProps.showMoreRel) {
        this.props.hideModal(SEE_ALL_MODAL);
      } else {
        this.props.showModal(SEE_ALL_MODAL);
      }
    }
  }

  render() {
    if (!this.props.showMoreRel) return null;

    return (
      <Fragment>
        <div ref={this.seeMoreRef} className="show-more-categories-modal">
          {this.props.route && (
            <div className="header">
              <CommonHeader
                link={this.props.route}
                showCategoryLabel={this.state.showCategoryLabel}
                tournamentPreview={this.props.tournamentPreview}
                detailsAvailable={this.props.detailsAvailable}
                onInfoClick={() => {
                  let params = this.props.qs;
                  params.tournamentDetails = this.props.route.get("rel");

                  let newLoc = `${
                    this.props.location.pathname
                  }?${queryString.stringify(params)}`;
                  this.props.navigateTo(newLoc);
                }}
                leftPanel={() => {
                  return (
                    <span
                      className="float-left prev-btn"
                      onClick={this.onClickPrevious}
                    >
                      <PreviousIcon width="34" />
                    </span>
                  );
                }}
                rightPanel={() => {
                  return (
                    <CloseIcon
                      width="34"
                      onClick={() => {
                        this.props.navigateTo(this.props.location.pathname);
                      }}
                    />
                  );
                }}
              />
            </div>
          )}
          <div className="content">
            {this.props.route && (
              <span className={`label`}>{this.props.route.get("name")}</span>
            )}

            <CategoryFiltersComponent
              filters={this.props.filters}
              filterRoute={this.props.filtersRoute}
              fetchFilters={(route) => {
                let params = new URLSearchParams();
                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    //if(filter.get('id') !== "providers") {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                    //}
                  });
                }
                this.props.clearGames(this.props.route);
                this.props.fetchFilters(route, params);
              }}
              onApplyFilterClickHandler={(filter) => {
                this.onApplyFilterClickHandler();
                this.setState({
                  activeFilter: filter.get("id"),
                });
              }}
              onSortClick={() => {
                this.onApplyFilterClickHandler();
                this.setState({
                  activeFilter: "sortBy",
                });
              }}
              onFilterClickHandler={this.props.setActiveFilter}
              showSelectedFilter={false}
              games={this.props.games}
              link={this.props.route}
              sortBy={this.props.sortBy}
              sorts={this.props.sorts}
              enableClearAll={this.props.enableClearAll}
              clearAllFilters={this.props.clearAllFilters}
              isMobile={this.props.isMobile}
              sortingSize={this.props.sortingSize}
              filtersIsLoading={this.props.filtersIsLoading}
            />
            <CategoryGames
              route={this.props.route}
              hasNoFilters={!this.props.filtersRoute}
              refreshList={!this.props.filtersIsLoading}
              itemComponent={ProviderTypeListItem}
              isMobile={this.props.isMobile}
              isLoading={this.props.isLoading}
              isLoadingNext={this.props.isLoadingNext}
              hasNextPage={this.props.hasNextPage}
              games={this.props.games}
              sortBy={this.props.sortBy}
              currency={this.props.currency}
              fetchGames={() => {
                let params = new URLSearchParams();
                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                  });
                }
                if (this.props.sortBy) {
                  params.append("sortBy", this.props.sortBy);
                }

                if (this.props.size) {
                  params.append("size", this.props.size);
                }

                return this.props.fetchGames(this.props.route, params);
              }}
              onGameItemClickHandler={(item) => {
                let categoryLink = item.game.getIn(["links", 0]);
                this.onShowMoreHandler(categoryLink.get("rel"), categoryLink);
              }}
              imageFormat={this.props.imageFormat}
              latestBroadcast={this.props.latestBroadcast}
              onReachEnd={() => {
                let params = new URLSearchParams();
                params.append("page", this.props.page + 1);

                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                  });
                }
                if (this.props.sortBy) {
                  params.append("sortBy", this.props.sortBy);
                }

                if (this.props.size) {
                  params.append("size", this.props.size);
                }

                return this.props.fetchGames(this.props.route, params);
              }}
            />
          </div>
        </div>
        <ShowMoreFilters
          activeFilter={this.state.activeFilter}
          filters={this.props.filters}
          filtersLink={this.props.filtersRoute}
          sorts={this.props.sorts}
          games={this.props.games}
          onClose={() => {
            this.setState({
              activeFilter: null,
            });
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let qs = queryString.parse(window.location.search);
  let { showMore, route } = qs;
  let routeDecrypt = fromJS(JSON.parse(decodeURIComponent(atob(route))));
  let filtersRoute;
  let filters;
  let filtersIsLoading;
  let enabledFilters;
  let sortBy;
  let sorts;
  let games;
  let isLoadingNext;
  let isLoading = true;
  let detailsAvailable = false;
  let enableClearAll;
  let sortingSize = 0;
  let hasNextPage;
  let page;
  let size = 10;

  try {
    games = state.games.getIn([showMore, "data"]);
  } catch (err) {}
  try {
    page = games.get("page");
  } catch (err) {}
  try {
    hasNextPage = games.get("totalPages") > games.get("page");
  } catch (err) {}
  try {
    size = games.get("size");
  } catch (err) {}
  try {
    isLoading = state.games.getIn([showMore, "isLoading"]);
  } catch (err) {}
  try {
    isLoadingNext = state.games.getIn([showMore, "isLoadingNext"]);
  } catch (err) {}
  try {
    detailsAvailable = routeDecrypt.getIn(["links"]) ? true : false;
  } catch (err) {}
  try {
    filtersRoute = routeDecrypt.getIn(["links"]).find((link) => {
      return link.get("rel").indexOf("-filters") > -1;
    });
    filtersRoute = filtersRoute.setIn(
      ["rel"],
      `show.more.${filtersRoute.getIn(["rel"])}`
    );
  } catch (err) {}
  try {
    sortBy = state.filters.getIn([filtersRoute.get("rel"), "data", "sortBy"]);
  } catch (err) {}

  try {
    sorts = state.filters.getIn([filtersRoute.get("rel"), "data", "sorts"]);
  } catch (err) {}

  try {
    filters = state.filters.getIn([filtersRoute.get("rel"), "data", "filters"]);
  } catch (err) {}
  try {
    enabledFilters = state.filters.getIn([
      filtersRoute.get("rel"),
      "data",
      "filters",
    ]);
  } catch (err) {}
  try {
    let toggledSize = 0;
    for (var i = 0; filters.size > i; i++) {
      toggledSize = filters.getIn([i, "toggledCount"]);
      sortingSize = sortingSize + toggledSize;
    }
  } catch (err) {}
  try {
    filtersIsLoading = state.filters.getIn([
      filtersRoute.get("rel"),
      "isLoading",
    ]);
  } catch (err) {}
  try {
    enableClearAll = state.filters.getIn([
      filtersRoute.get("rel"),
      "enableClearAll",
    ]);
  } catch (err) {}

  return {
    isMobile: state.window.get("isMobile"),
    route: routeDecrypt,
    filtersRoute,
    filters,
    filtersIsLoading,
    enabledFilters,
    enableClearAll,
    sortBy,
    sorts,
    qs,
    detailsAvailable,
    showMoreRel: showMore,
    games,
    isLoading,
    isLoadingNext,
    sortingSize,
    hasNextPage,
    page,
    size,
    isMultiGame: state.links.get("isMultiGame"),
    imageFormat: state.window.get("imageFormat"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchFilters: (route, params) => dispatchProps.fetchFilters(route, params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    clearGames: (route) => dispatchProps.clearGames(route),
    navigateTo: (path) => ownProps.history.push(path),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchTournamentPreview: (link, params) =>
      dispatchProps.fetchTournamentPreview(link, params),
    showFilters: (bol) => dispatchProps.showFilters(bol),
    setActiveFilter: (category, subCategory, filter) =>
      dispatchProps.setActiveFilter(category, subCategory, filter),
    clearAllFilters: (category) => dispatchProps.clearAllFilters(category),
    setCategorySorting: (route, sorting) =>
      dispatchProps.setCategorySorting(route, sorting),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ShowMoreCategories);
